import React from 'react';
import './DownloadCardSupportingText.scss';

const DownloadCardSupportingText = ({ children }) => {
    return <div className="supporting-text">{children}</div>;
};

export default DownloadCardSupportingText;
